import {
  CREATING_CONVERSATION_REQUEST, CREATING_CONVERSATION_SUCCEDDED, CREATING_CONVERSATION_FAILED,
  FETCHING_CONVERSATIONS_REQUEST, FETCHING_CONVERSATIONS_SUCCEDDED, FETCHING_CONVERSATIONS_FAILED, INVALIDATE_CONVERSATIONS,
  FETCHING_CONVERSATION_REQUEST, FETCHING_CONVERSATION_SUCCEDDED, FETCHING_CONVERSATION_FAILED, INVALIDATE_CONVERSATION,
  FETCHING_CONVERSATION_ASSET_ANALYTICS_REQUEST, FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEDDED,
  FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED,
  UPDATING_SHARE_REQUEST, UPDATING_SHARE_SUCCEDDED, UPDATING_SHARE_FAILED,
  UPDATING_CONVERSATION_RECIPIENT_REQUEST, UPDATING_CONVERSATION_RECIPIENT_SUCCEDDED, UPDATING_CONVERSATION_RECIPIENT_FAILED,
 ADD_ASSET_TO_SHARE_SUCCEDDED, ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED, ADD_ASSET_TO_SHARE_FAILED,
  RESENDING_CONVERSATION_REQUEST, RESENDING_CONVERSATION_SUCCEDDED, RESENDING_CONVERSATION_FAILED,
  FETCHING_SHARE_SECTION_REQUEST, FETCHING_SHARE_SECTION_SUCCEDDED, FETCHING_SHARE_SECTION_FAILED,
  DELETING_CONVERSATION_REQUEST, DELETING_CONVERSATION_SUCCEDDED, DELETING_CONVERSATION_FAILED,
  CONVERSATION_APPLY_ADDITIONAL_CHANGES,
  FETCHING_MESSAGE_REQUEST, FETCHING_MESSAGE_SUCCEDDED, FETCHING_MESSAGE_FAILED,
  FETCHING_ASSET_PREVIEW, FETCHING_ASSET_PREVIEW_SUCCEDDED, FETCHING_ASSET_PREVIEW_FAILED,
  FETCHING_SHARE_RECIPIENTS_REQUEST, FETCHING_SHARE_RECIPIENTS_SUCCEDDED, FETCHING_SHARE_RECIPIENTS_FAILED, INVALIDATE_SHARE_RECIPIENTS,
  FETCHING_SHARE_ASSETS_REQUEST, FETCHING_SHARE_ASSETS_SUCCEDDED, FETCHING_SHARE_ASSETS_FAILED,
  ADD_OPPORTUNITY_TO_SHARE, ADD_OPPORTUNITY_TO_SHARE_SUCCEEDED, ADD_OPPORTUNITY_TO_SHARE_FAILED,
  REMOVE_OPPORTUNITY_FROM_SHARE, REMOVE_OPPORTUNITY_FROM_SHARE_SUCCEEDED, REMOVE_OPPORTUNITY_FROM_SHARE_FAILED,
  FETCH_RECIPIENT_INFO, FETCHING_RECIPIENT_INFO_SUCCEEDED, FETCHING_RECIPIENT_INFO_FAILED, FETCHING_CONVERSATION_EVENTS, FETCHING_CONVERSATION_EVENTS_SUCCEEDED, FETCHING_CONVERSATION_EVENTS_FAILED,
  UPDATE_ASSET_ADDITIONAL_DATA_IN_CONVERSATION
} from '../actions/actionTypes';

import _ from 'lodash';

const initialState = {
  loading: false,
  invalidated: true,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1
  },
  conversation: {
    loading: false,
    loadingRecipients: false,
    loadingAssets: false,
    item: {},
    creating: false,
    deleting: false,
    resending: false,
    error: null
  },
  recipientInfo: []
};

const conversationDetailsState = {
  loading: false,
  updating: false,
  item: null,
  error: {},
  message: {
    loading: false,
    item: null
  }
}

const conversationRecipientState = {
  loading: false,
  invalidated: true,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1,
    totalRecordsCount: 0
  },
}

const opportunityState = {
  loading: false,
  invalidated: true,
  item: null,
  errors: null
};

const eventsInitialState = {
  loading: false,
  items: [],
  error: null,
  pagination: {
    current: 1,
    totalPages: 1,
    totalRecordsCount: 0,
  }
};

function conversationReducer(state = initialState, action) {
  var recipients = [];
  switch (action.type) {
    case CREATING_CONVERSATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          creating: true
        }
      })
    case CREATING_CONVERSATION_SUCCEDDED:
      var items = [action.payload, ...state.items];

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          creating: false
        },
        items: items,
      })
    case CREATING_CONVERSATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          creating: false,
          error: action.payload.error
        }
      })

    case FETCHING_CONVERSATIONS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        loading: true,
        invalidated: true
      })
    case FETCHING_CONVERSATIONS_SUCCEDDED:
      var records = action.payload.records;
      var items = [];
      if (action.payload.currentPage == 0) {
        items = records;
      } else {
        items = [...state.items, ...records];
      }
      items = _.uniqBy(items, "id");

      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: action.payload.currentPage,
          totalPages: action.payload.totalPages
        }
      })
    case FETCHING_CONVERSATIONS_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error
      })
    case INVALIDATE_CONVERSATIONS:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: true,
        items: [],
        pagination: {
          current: -1,
          totalPages: 1
        }
      })

    case FETCHING_CONVERSATION_REQUEST:
      var id = action.payload;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              loading: true,
            }
          }
        }
      })
    case FETCHING_CONVERSATION_SUCCEDDED:
      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              loading: false,
              item: {
                ...action.payload.conversation,
                recipients: conversationRecipientState,
                assets: [],
                sections: [],
                events: {
                  ...eventsInitialState
                }
              }
            }
          }
        },
        items: state.items.map(item => {
          if (item.id == id) {
            return Object.assign({}, item, {
              ...item,
              uniqueEmailOpens: action.payload.conversation.uniqueEmailOpens,
              totalTimeSpent: action.payload.conversation.totalTimeSpent
            })
          } else {
            return item;
          }
        })
      })
    case FETCHING_CONVERSATION_FAILED:
      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              loading: false,
              error: action.payload.error
            }
          }
        }
      })

    case FETCHING_CONVERSATION_EVENTS:
      var conversationID = action.payload.request.share;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      var events = _.get(state,`conversation.item[${conversationID}].item.events`) || eventsInitialState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              item: {
                ...conversation.item,
                events: {
                  ...events,
                  loading: true
                }
              }
            }
          }
        }
      });

    case FETCHING_CONVERSATION_EVENTS_SUCCEEDED:
      var conversationID = action.payload.request.share;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;
      var events = state.conversation.item[conversationID].item.events || eventsInitialState;

      var items = [];

      if (action.payload.data.currentPage != 0) {
        items = [...events.items, ...action.payload.data.records];
      } else {
        items = action.payload.data.records
      }

      items = _.uniqBy(items, 'id');

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              item: {
                ...conversation.item,
                events: {
                  ...events,
                  loading: false,
                  items: items,
                  pagination: {
                    ...events.pagination,
                    current: action.payload.data.currentPage,
                    totalPages: action.payload.data.totalPages,
                  }
                }
              }
            }
          }
        }
      });

    case FETCHING_CONVERSATION_EVENTS_FAILED:
      var conversationID = action.payload.request.share;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;
      var events = state.conversation.item[conversationID].item.events || eventsInitialState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              item: {
                ...conversation.item,
                events: {
                  ...events,
                  loading: false,
                  error: action.payload.error
                }
              }
            }
          }
        }
      });

    case FETCHING_SHARE_SECTION_REQUEST:
      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      var sections = conversation.item.sections.map(section => {
        if (section.id === action.payload.section) {
          return {
            ...section,
            loading: true
          }
        } else {
          return section;
        }
      })

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                sections: sections
              }
            }
          }
        }
      })

    case FETCHING_SHARE_SECTION_SUCCEDDED:
      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      var sections = conversation.item.sections.map(section => {
        if (section.id === action.payload.section.id) {
          var assets = action.payload.section.assets || [];
          assets = assets.map((asset) => {
            return Object.assign({}, asset, {
              ...asset,
              analytics: {
                fetch: true,
                loading: false,
                item: null
              },
              preview: {
                loading: false,
                item: null,
                fetch: true
              }
            })
          });

          return {
            ...section,
            loading: false,
            fetched: true,
            assets: assets
          }
        } else {
          return section;
        }
      })

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                sections: sections
              }
            }
          }
        }
      })

    case FETCHING_SHARE_SECTION_FAILED:
      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      var sections = conversation.item.sections.map(section => {
        if (section.id === action.payload.section) {
          return {
            ...section,
            loading: false,
            fetched: false,
            error: action.payload.error
          }
        } else {
          return section;
        }
      })

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                sections: sections
              }
            }
          }
        }
      })

    case DELETING_CONVERSATION_REQUEST:
      var id = action.payload;
      var conversation = state[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...conversation,
          deleting: true
        }
      });

    case DELETING_CONVERSATION_SUCCEDDED:
      var id = action.payload;
      var conversation = state[id] || conversationDetailsState;

      var items = state.items.filter(item => {
        return item.id !== id;
      })

      return Object.assign({}, state, {
        ...state,
        items: items,
        [id]: {
          ...conversation,
          item: null,
          deleting: false
        }
      });

    case DELETING_CONVERSATION_FAILED:
      var id = action.payload;
      var conversation = state[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        [id]: {
          ...conversation,
          deleting: false,
          error: action.payload.error
        }
      });

    case CONVERSATION_APPLY_ADDITIONAL_CHANGES:
      var id = action.payload.id;
      var changes = action.payload.changes;

      var conversation = state.conversation.item[id] || conversationDetailsState;

      var sections = conversation.item && conversation.item.sections && conversation.item.sections.map((section, index) => {
        var sectionChanges = changes.sections[index];

        var assets = sectionChanges.assets || [];
        assets = assets.map((asset) => {
          return Object.assign({}, asset, {
            ...asset,
            analytics: {
              fetch: true,
              loading: false,
              item: null
            },
            preview: {
              loading: false,
              item: null,
              fetch: true
            }
          })
        });

        return {
          ...section,
          ...sectionChanges,
          loading: false,
          fetched: _.get(sectionChanges,"fetched", false),
          assets: assets
        }
      })

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                sections: sections
              }
            }
          }
        }
      });

    case INVALIDATE_CONVERSATION:
      var conversationID = action.payload;

      var conversations = Object.keys(state.conversation.item).reduce((result, key) => {
        if (key !== conversationID) {
          result[key] = state[key];
        }
        return result;
      }, {});

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: conversations
        }
      });

    case FETCHING_CONVERSATION_ASSET_ANALYTICS_REQUEST:
      var conversationID = action.payload.conversationID;
      var sectionID = action.payload.sectionID;
      var assetID = action.payload.assetID;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      if (sectionID == null && sectionID < 0) {
        var items = conversation.item.assets.map((asset) => {
          if (asset.id == assetID) {
            return Object.assign({}, asset, {
              ...asset,
              analytics: {
                ...asset.analytics,
                fetch: false,
                loading: true,
              },
              preview: {
                loading: false,
                item: null,
                fetch: true
              }
            })
          }

          return asset;
        });

        return Object.assign({}, state, {
          ...state,
          conversation: {
            ...state.conversation,
            item: {
              ...state.conversation.item,
              [conversationID]: {
                ...conversation,
                item: {
                  ...conversation.item,
                  assets: items
                }
              }
            }
          }
        })
      } else {
        var sections = conversation.item && conversation.item.sections && conversation.item.sections.map((section) => {
          if (section.id == sectionID) {
            var assets = section.assets.map(asset => {
              if (asset.id == assetID) {
                return Object.assign({}, asset, {
                  ...asset,
                  analytics: {
                    ...asset.analytics,
                    fetch: false,
                    loading: true,
                  },
                  preview: {
                    loading: false,
                    item: null,
                    fetch: true
                  }
                })
              }

              return asset
            })

            return {
              ...section,
              assets: assets
            }
          } else {
            return section;
          }
        })

        return Object.assign({}, state, {
          ...state,
          conversation: {
            ...state.conversation,
            item: {
              ...state.conversation.item,
              [conversationID]: {
                ...conversation,
                item: {
                  ...conversation.item,
                  sections: sections
                }
              }
            }
          }
        })
      }

    case FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEDDED:
      var conversationID = action.payload.conversationID;
      var sectionID = action.payload.sectionID;
      var assetID = action.payload.assetID;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      if (!sectionID) {
        var items = conversation.item.assets.map((asset) => {
          if (asset.id == assetID) {
            return Object.assign({}, asset, {
              ...asset,
              analytics: {
                ...asset.analytics,
                fetch: false,
                loading: false,
                item: action.payload.json
              }
            })
          }

          return asset;
        });

        return Object.assign({}, state, {
          ...state,
          conversation: {
            ...state.conversation,
            item: {
              ...state.conversation.item,
              [conversationID]: {
                ...conversation,
                item: {
                  ...conversation.item,
                  assets: items
                }
              }
            }
          }
        })
      } else {
        var sections = conversation.item.sections.map((section) => {
          if (section.id == sectionID) {
            var assets = section.assets.map(asset => {
              if (asset.id == assetID) {
                return Object.assign({}, asset, {
                  ...asset,
                  analytics: {
                    ...asset.analytics,
                    fetch: false,
                    loading: false,
                    item: action.payload.json
                  }
                })
              }

              return asset
            })

            return {
              ...section,
              assets: assets
            }
          } else {
            return section;
          }
        })

        return Object.assign({}, state, {
          ...state,
          conversation: {
            ...state.conversation,
            item: {
              ...state.conversation.item,
              [conversationID]: {
                ...conversation,
                item: {
                  ...conversation.item,
                  sections: sections
                }
              }
            }
          }
        })
      }
    case FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED:
      var conversationID = action.payload.conversationID;
      var assetID = action.payload.assetID;
      var sectionID = action.payload.sectionID;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      if (!sectionID) {
        var items = _.get(conversation.item,"assets",[]).map((asset) => {
          if (asset.id == assetID) {
            return Object.assign({}, asset, {
              ...asset,
              analytics: {
                ...asset.analytics,
                fetch: false,
                loading: false,
                error: action.payload.error
              },
              preview: {
                loading: false,
                item: null,
                fetch: true
              }
            })
          }

          return asset;
        });

        return Object.assign({}, state, {
          ...state,
          conversation: {
            ...state.conversation,
            item: {
              ...state.conversation.item,
              [conversationID]: {
                ...conversation,
                item: {
                  ...conversation.item,
                  assets: items
                }
              }
            }
          }
        })
      } else {
        var sections = conversation.item.sections.map((section) => {
          if (section.id == sectionID) {
            var assets = section.assets.map(asset => {
              if (asset.id == assetID) {
                return Object.assign({}, asset, {
                  ...asset,
                  analytics: {
                    ...asset.analytics,
                    fetch: false,
                    loading: false,
                    error: action.payload.error
                  },
                  preview: {
                    loading: false,
                    item: null,
                    fetch: true
                  }
                })
              }

              return asset
            })

            return {
              ...section,
              assets: assets
            }
          } else {
            return section;
          }
        })

        return Object.assign({}, state, {
          ...state,
          conversation: {
            ...state.conversation,
            item: {
              ...state.conversation.item,
              [conversationID]: {
                ...conversation,
                item: {
                  ...conversation.item,
                  sections: sections
                }
              }
            }
          }
        })
      }

    case FETCHING_ASSET_PREVIEW:
      var assetID = action.payload.id;

      var conversations = Object.values(state.conversation.item);
      conversations = conversations.map(conversation => {
        if (!conversation || !conversation.item) {
          return conversation;
        }

        var sections = conversation.item.sections || [];
        var updatedSections = sections.map(section => {
          var sectionAssets = section.assets || [];

          var assets = sectionAssets.map(asset => {
            if (asset.id == assetID) {
              return Object.assign({}, asset, {
                ...asset,
                preview: {
                  loading: true,
                  item: null,
                  fetch: false
                }
              })
            }

            return asset;
          })
          return {
            ...section,
            assets: assets
          }
        });
        var assets = conversation.item.assets || [];

        assets = assets.map(asset => {
          if (asset.id == assetID) {
            return Object.assign({}, asset, {
              ...asset,
              preview: {
                loading: true,
                item: null,
                fetch: false
              }
            })
          }

          return asset;
        })

        return Object.assign({}, conversation, {
          ...conversation,
          item: {
            ...conversation.item,
            sections: updatedSections,
            assets: assets
          }

        });
      });

      var updatedConversations = {};
      conversations.filter(conversation => conversation && conversation.item).forEach(conversation => {
        updatedConversations[conversation.item.id] = conversation;
      });

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            ...updatedConversations
          }
        }
      })

    case FETCHING_ASSET_PREVIEW_SUCCEDDED:
      var assetID = action.payload.id;

      var conversations = Object.values(state.conversation.item);
      conversations = conversations.map(conversation => {
        if (!conversation || !conversation.item) {
          return conversation;
        }

        var sections = conversation.item.sections || [];
        var updatedSections = sections.map(section => {
          var sectionAssets = section.assets || [];

          var assets = sectionAssets.map(asset => {
            if (asset.id == assetID) {
              return Object.assign({}, asset, {
                ...asset,
                preview: {
                  loading: false,
                  item: action.payload.result,
                  fetch: false
                }
              })
            }

            return asset;
          })
          return {
            ...section,
            assets: assets
          }
        });

        var assets = conversation.item.assets || [];

        assets = assets.map(asset => {
          if (asset.id == assetID) {
            return Object.assign({}, asset, {
              ...asset,
              preview: {
                loading: false,
                item: action.payload.result,
                fetch: false
              }
            })
          }

          return asset;
        })

        return Object.assign({}, conversation, {
          ...conversation,
          item: {
            ...conversation.item,
            sections: updatedSections,
            assets: assets
          }
        });
      });

      var updatedConversations = {};
      conversations.filter(conversation => conversation && conversation.item).forEach(conversation => {
        updatedConversations[conversation.item.id] = conversation;
      });

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            ...updatedConversations
          }
        }
      })

    case FETCHING_ASSET_PREVIEW_FAILED:
      var assetID = action.payload.id;

      var conversations = Object.values(state.conversation.item);
      conversations = conversations.map(conversation => {
        if (!conversation || !conversation.item) {
          return conversation;
        }

        var sections = conversation.item.sections || [];
        var updatedSections = sections.map(section => {
          var sectionAssets = section.assets || [];

          var assets = sectionAssets.map(asset => {
            if (asset.id == assetID) {
              return Object.assign({}, asset, {
                ...asset,
                preview: {
                  item: null,
                  error: action.payload.error,
                  fetch: true
                }
              })
            }

            return asset;
          })
          return {
            ...section,
            assets: assets
          }
        });
        var assets = conversations.assets || [];

        assets = assets.map(asset => {
          if (asset.id == assetID) {
            return Object.assign({}, asset, {
              ...asset,
              preview: {
                loading: false,
                item: null,
                error: action.payload.error,
                fetch: true
              }
            })
          }

          return asset;
        })

        return Object.assign({}, conversation, {
          ...conversation,
          sections: updatedSections,
          assets: assets
        });
      });

      var updatedConversations = {};
      conversations.filter(conversation => conversation && conversation.item).forEach(conversation => {
        updatedConversations[conversation.item.id] = conversation;
      });

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            ...updatedConversations
          }
        }
      })

    case ADD_ASSET_TO_SHARE_SUCCEDDED:
      var share = action.payload.share;

      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      if (!conversation.item) {
        return state;
      }

      var assets = share.assets.filter((asset) => {
        var found = conversation.item.assets.find((item) => {
          return item.id == asset.id;
        })

        return found == null
      });


      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                assets: [...conversation.item.assets, ...assets]
              }
            }
          }
        }
      })

    case ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED:
      var shareId = action.payload.share;
      var conversation = state.conversation.item[shareId] || conversationDetailsState;

      if (!conversation.item) {
        return state;
      }

      var currentSection = action.payload.section;
      var sectionId = action.payload.id;

      var sections = (conversation.item.sections || []).map((section) => {
        if (section.id === sectionId) {
          var assets = section.assets.filter((asset) => {
            var found = currentSection.assets.find((item) => {
              return item.id == asset.id;
            })

            return found == null
          });

          return {
            ...section,
            assets: [...currentSection.assets, ...assets]
          }
        } else {
          return section;
        }
      });

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [shareId]: {
              ...conversation,
              item: {
                ...conversation.item,
                sections: sections
              }
            }
          }
        }
      });

    case ADD_ASSET_TO_SHARE_FAILED:
      console.log("add asset to share failed");
      return state;


    case UPDATING_SHARE_REQUEST:
      var conversationID = action.payload;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              updating: true,
              error: {}
            }
          }
        }
      });

    case UPDATING_SHARE_SUCCEDDED:
      var conversationID = action.payload.conversationID;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      var assets = action.payload.share.assets.map((asset) => {
        return Object.assign({}, asset, {
          ...asset,
          analytics: {
            fetch: true,
            loading: false,
            item: null
          }
        })
      })

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              updating: false,
              item: {
                ...conversation.item,
                ...action.payload.share,
                recipients: conversation.item.recipients,
                assets: assets
              }
            }
          }
        }
      })

    case UPDATING_SHARE_FAILED:
      var conversationID = action.payload.conversationID;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              updating: false,
              error: action.payload.error
            }
          }
        }
      });

    case UPDATING_CONVERSATION_RECIPIENT_REQUEST:
      var conversationID = action.payload.conversationID;
      var recipientID = action.payload.recipientID;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  ...conversation.item.recipients,
                  items: conversation.item.recipients.items.map((recipient) => {
                    if (recipient.item.contact && recipient.item.contact.id === recipientID) {
                      return {
                        ...recipient,
                        item: {
                          ...recipient.item,
                          updating: true
                        }
                      }
                    }

                    return recipient
                  })
                }
              }
            }
          }
        }
      });

    case UPDATING_CONVERSATION_RECIPIENT_SUCCEDDED:
      var conversationID = action.payload.conversationID;
      var recipientID = action.payload.recipientID;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  ...conversation.item.recipients,
                  items: conversation.item.recipients.items.map((recipient) => {
                    if (recipient.item.contact && recipient.item.contact.id === recipientID) {
                      var updatedRecipient = {
                        ...recipient,
                        item: {
                          ...recipient.item,
                          active: action.payload.recipient.active,
                          accessRemovedDate: action.payload.recipient.accessRemovedDate,
                          updating: false,
                        }
                      }
                      return {
                        ...updatedRecipient
                      }
                    }

                    return recipient
                  })
                }
              }
            }
          }
        }
      });

    case UPDATING_CONVERSATION_RECIPIENT_FAILED:
      var conversationID = action.payload.conversationID;
      var recipientID = action.payload.recipientID;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  ...conversation.item.recipients,
                  items: conversation.item.recipients.items.map((recipient) => {
                    if (recipient.item.contact && recipient.item.contact.id === recipientID) {
                      return {
                        ...recipient,
                        item: {
                          ...recipient.item,
                          updating: false
                        }
                      }
                    }

                    return recipient
                  })
                }
              }
            }
          }
        }
      });

    case RESENDING_CONVERSATION_REQUEST:
      var conversationID = action.payload.conversationID;
      var shareID = action.payload.shareID;
      var conversation = state.conversation.item[shareID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [shareID]: {
              ...conversation,
              resending: true
            }
          }
        }
      });
    case RESENDING_CONVERSATION_SUCCEDDED:
      var conversationID = action.payload.conversationID;
      var shareID = action.payload.shareID;
      var conversation = state.conversation.item[shareID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [shareID]: {
              ...conversation,
              resending: false
            }
          }
        }
      });
    case RESENDING_CONVERSATION_FAILED:
      var conversationID = action.payload.conversationID;
      var shareID = action.payload.shareID;
      var conversation = state.conversation.item[shareID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [shareID]: {
              ...conversation,
              resending: false,
              error: action.payload.error
            }
          }
        }
      });

    case FETCHING_MESSAGE_REQUEST:
      var id = action.payload;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              message: {
                ...conversation.message,
                loading: true,
              }
            }
          }
        }
      });

    case FETCHING_MESSAGE_SUCCEDDED:
      var id = action.payload.shareId;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              message: {
                ...conversation.message,
                loading: false,
                item: action.payload.message
              }
            }
          }
        }
      });

    case FETCHING_MESSAGE_FAILED:
      var id = action.payload.shareId;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              message: {
                ...conversation.message,
                loading: false,
                error: action.payload.error
              }
            }
          }
        }
      });

    case FETCHING_SHARE_RECIPIENTS_REQUEST:
      var id = action.payload;

      var conversation = _.get(state.conversation,`item[${id}]`)|| conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  ...conversation.item?.recipients,
                  loading: true
                }
              }
            }
          }
        }
      })

    case FETCHING_SHARE_RECIPIENTS_SUCCEDDED:
      var id = action.payload.id;
      var response = action.payload.response;

      var conversation = state.conversation.item[id] || conversationDetailsState;
      recipients = response.records;
      var recipients = recipients.map((recipient) => {
        return {
          id: recipient.id,
          item: {
            ...recipient
          }
        }
      });

      var previousRecipients = _.get(conversation, 'item.recipients.items') || [];
      recipients = [...previousRecipients, ...recipients];
      
      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  ...conversation.item?.recipients,
                  loading: false,
                  items: recipients,
                  pagination: {
                    ...conversation.item?.recipients?.pagination,
                    current: response.currentPage,
                    totalPages: response.totalPages,
                    totalRecordsCount: response.totalRecordsCount
                  }
                }
              }
            }
          }
        }
      })

    case FETCHING_SHARE_RECIPIENTS_FAILED:
      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  ...conversation?.item?.recipients,
                  loading: true,
                  error: action.payload.error
                }
              }
            }
          }
        }
      })
    case INVALIDATE_SHARE_RECIPIENTS:
      var id = action.payload;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  items: [],
                  pagination: {
                    ...conversation.item.recipients.pagination,
                    current: -1,
                    totalPages: 1
                  }
                }
              }
            }
          }
        }
      })

    case FETCHING_SHARE_ASSETS_REQUEST:
      var id = action.payload;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              loadingAssets: true,
            }
          }
        }
      })

    case FETCHING_SHARE_ASSETS_SUCCEDDED:
      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      var sections = action.payload.conversation.sections || [];
      var assets = action.payload.conversation.assets || [];
      assets = assets.map((asset) => {
        return Object.assign({}, asset, {
          ...asset,
          analytics: {
            fetch: true,
            loading: false,
            item: null
          },
          preview: {
            loading: false,
            item: null,
            fetch: true
          }
        })
      });

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              loadingAssets: false,
              item: {
                ...conversation.item,
                assets: assets,
                sections: sections
              }
            }
          }
        }
      })

    case FETCHING_SHARE_ASSETS_FAILED:
      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              loadingAssets: false,
              error: action.payload.error
            }
          }
        }
      })

    case ADD_OPPORTUNITY_TO_SHARE:
      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
            }
          }
        }
      })

    case ADD_OPPORTUNITY_TO_SHARE_SUCCEEDED:

      var id = action.payload.id;
      var opportunity = action.payload.data;

      var conversation = state.conversation.item[id] || conversationDetailsState;
      var opportunities = (conversation.item.opportunities || []);
      opportunities = [...opportunities, opportunity];
      opportunities = _.uniqBy(opportunities, 'id');

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                opportunities: opportunities
              }
            }
          }
        }
      })

    case ADD_OPPORTUNITY_TO_SHARE_FAILED:

      var id = action.payload.id;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                error: action.payload.error
              }
            }
          }
        }
      })

    case REMOVE_OPPORTUNITY_FROM_SHARE:
      var id = action.payload.id;
      var opportunityId = action.payload.opportunity;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      var opportunities = (conversation.item.opportunities || []).map(opportunity => {
        if (opportunity.id === opportunityId) {
          return {
            ...opportunity,
            deleting: true
          }
        }

        return opportunity;
      });

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                opportunities: opportunities
              }
            }
          }
        }
      })

    case REMOVE_OPPORTUNITY_FROM_SHARE_SUCCEEDED:
      var id = action.payload.id;
      var opportunityId = action.payload.opportunity;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      var opportunities = (conversation.item.opportunities || []).filter(opportunity => {
        return opportunity.id != opportunityId;
      });

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                opportunities: opportunities
              }
            }
          }
        }
      })

    case REMOVE_OPPORTUNITY_FROM_SHARE_FAILED:
      var id = action.payload.id;
      var opportunityId = action.payload.opportunity;
      var conversation = state.conversation.item[id] || conversationDetailsState;

      var opportunities = (conversation.item.opportunities || []).map(opportunity => {
        if (opportunity.id === opportunityId) {
          return {
            ...opportunity,
            deleting: false,
            error: action.payload.error
          }
        }

        return opportunity;
      });

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [id]: {
              ...conversation,
              item: {
                ...conversation.item,
                opportunities: action.payload.data
              }
            }
          }
        }
      })

    case FETCH_RECIPIENT_INFO:
      var conversationID = action.payload.shareId;
      var recipientID = action.payload.recipient;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  ...conversation.item.recipients,
                  items: conversation.item.recipients.items.map((recipient) => {
                    if ((recipient.item.contact && recipient.item.contact.id === recipientID) || 
                          (recipient.item.visitor && recipient.item.visitor.id === recipientID)) {
                      return {
                        ...recipient,
                        item: {
                          ...recipient.item
                        }
                      }
                    }

                    return recipient
                  })
                }
              }
            }
          }
        }
      });

    case FETCHING_RECIPIENT_INFO_SUCCEEDED:
      var conversationID = action.payload.shareId;
      var recipientID = action.payload.recipient;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  ...conversation.item.recipients,
                  items: conversation.item.recipients.items.map((recipient) => {
                    if ((recipient.item.contact && recipient.item.contact.id === recipientID) || 
                          (recipient.item.visitor && recipient.item.visitor.id === recipientID)) {
                      var updatedRecipient = {
                        ...recipient,
                        item: {
                          ...recipient.item,
                          recipientInfo: action.payload.data
                        }
                      }
                      return {
                        ...updatedRecipient
                      }
                    }

                    return recipient
                  })
                }
              }
            }
          }
        }
      });

    case FETCHING_RECIPIENT_INFO_FAILED:
      var conversationID = action.payload.shareId;
      var recipientID = action.payload.recipient;
      var conversation = state.conversation.item[conversationID] || conversationDetailsState;

      return Object.assign({}, state, {
        ...state,
        conversation: {
          ...state.conversation,
          item: {
            ...state.conversation.item,
            [conversationID]: {
              ...conversation,
              item: {
                ...conversation.item,
                recipients: {
                  ...conversation.item.recipients,
                  items: conversation.item.recipients.items.map((recipient) => {
                    if ((recipient.item.contact && recipient.item.contact.id === recipientID) || 
                      (recipient.item.visitor && recipient.item.visitor.id === recipientID)) {
                      return {
                        ...recipient,
                        item: {
                          ...recipient.item
                        }
                      }
                    }

                    return recipient
                  })
                }
              }
            }
          }
        }
      });

    case UPDATE_ASSET_ADDITIONAL_DATA_IN_CONVERSATION:
      const sectionIndex = _.get(action, 'payload.section');
      const collectionId = _.get(action, 'payload.collection');
      const assetsToUpdate = _.get(action, 'payload.assets');

      var currentConversation = _.get(state,`conversation.item[${collectionId}]`);

      if(!currentConversation) {
        return state;
      }
      
      const conversationItem = _.get(currentConversation, 'item');
      if (_.size(conversationItem.sections) > 0 && sectionIndex) {
        const updatedSections = conversationItem.sections.map((section, index) => {
          if (index == sectionIndex) {
            return {
              ...section,
              assets: _.get(section, "assets", []).map(asset => {
                const assetToUpdate = _.find(assetsToUpdate, { id: asset.id });
                if (assetToUpdate && !asset.additionalMetadata) {
                  const dimension = assetToUpdate.dimension;
                  return {
                    ...asset,
                    additionalMetadata: {
                      xaxis: dimension.x,
                      yaxis: dimension.y,
                      width: dimension.width,
                      height: dimension.height
                    }
                  }
                }

                return asset;
              })
            }
          }

          return section;
        })

        return Object.assign({}, state, {
          ...state,
          conversation: {
            ...state.conversation,
            item: {
              ...state.conversation.item,
              [collectionId]: {
                ...currentConversation,
                item: {
                  ...conversationItem,
                  sections: updatedSections
                }
              }
            }
          }
        })
      }
      else{
        const assets = conversationItem.assets;
        var updatedAssets = assets.map(asset => {
          const assetToUpdate = _.find(assetsToUpdate, { id: asset.id });
          if (assetToUpdate && !asset.additionalMetadata) {
            const dimension = assetToUpdate.dimension;
            return {
              ...asset,
              additionalMetadata: {
                xaxis: dimension.x,
                yaxis: dimension.y,
                width: dimension.width,
                height: dimension.height
              }
            }
          }

          return asset;
        });

        return Object.assign({}, state, {
          ...state,
          conversation: {
            ...state.conversation,
            item: {
              ...state.conversation.item,
              [collectionId]:{
                ...currentConversation,
                item:{
                  ...conversationItem,
                  assets: updatedAssets
                }
              }
            }
          }
        });
      }

    default:
      return state
  }
}

export { conversationReducer };